<template>
  <form
    class="formCont"
    :action="dataBO.form.formUrl"
    @submit="validadeForms($event)"
  >
    <input type="hidden" name="id" value="hyundai_vue" />
    <input type="hidden" name="cfg" id="cfgXMLConfig" value="hyundai_vue_cfg" />

    <input type="hidden" name="form_type" id="cfgFormType" value="CFG" />
    <input
      type="hidden"
      name="from_page"
      id="cfgFormType"
      :value="$route.path"
    />
    <input type="hidden" name="lead_type" :value="dataBO.form.lead_type" />
    <input
      type="hidden"
      name="form_type_code"
      :value="dataBO.form.form_type_code"
    />

    <input
      type="hidden"
      name="redirok"
      id="redirok"
      value="https://www.hyundai.pt/mensagem-enviada"
    />
    <input
      type="hidden"
      name="redirnok"
      id="redirnok"
      value="https://www.hyundai.pt/problema-envio"
    />

    <input type="hidden" name="model" id="model" :value="resumeData.model" />
    <input
      type="hidden"
      name="id_model"
      id="id_model"
      :value="resumeData.modelid"
    />

    <input
      type="hidden"
      name="typeService"
      id="typeService"
      :value="dataBO.form.typeService"
    />
    <input type="hidden" name="modelSelected" id="modelSelected" value="" />
    <input type="hidden" name="addAllOption" id="addAllOption" value="false" />

    <input
      type="hidden"
      name="leadSource"
      :value="dataBO.isGov ? dataBO.form.leadSourceGov : dataBO.form.leadSource"
    />
    <input
      type="hidden"
      name="idSubscriptionCenterOrigin"
      :value="dataBO.form.idSubscriptionCenterOrigin"
    />
    <input
      type="hidden"
      name="contactType"
      id="contactType"
      :value="dataBO.form.contactType"
    />

    <input
      type="hidden"
      id="configurationID"
      name="configurationID"
      :value="resumeData.uniqueID"
    />
    <!-- <input type="hidden" id="configurationPDFE" name="configurationPDFE" value=""> -->

    <input type="hidden" name="utm_source" value="" />
    <input type="hidden" name="utm_medium" value="" />
    <input type="hidden" name="utm_campaign" value="" />
    <input type="hidden" name="utm_term" value="" />
    <input type="hidden" name="utm_content" value="" />

    <!-- *** Info -->
    <h2 class="formCont-title">
      Preencha os seus seguintes dados, para receber a sua configuração no seu
      email.
    </h2>
    <Input
      field="name"
      labelText="Nome"
      placeholder="Nome"
      :curValue.sync="name"
      :errorText="errorMsg.name"
      :isValid="formFieldsState.name"
    />

    <Input
      field="email"
      labelText="Email"
      placeholder="Email"
      :curValue.sync="email"
      :errorText="errorMsg.email"
      :isValid="formFieldsState.email"
    />

    <!-- *** CheckBox -->
    <CheckBox
      fieldClass="squareCheckbox acceptPP"
      field="accept"
      value="S"
      :isLink="true"
      :errorText="errorMsg.accept"
      :isValid="formFieldsState.accept"
      :fieldLabel="getAcceptText"
      @checked-item="handlePolicy($event)"
    />

    <CheckBox field="disclaimer" value="S" :fieldLabel="disclaimerText" />
    <button class="btn-primary" :disabled="pending">{{ btnLabel }}</button>
  </form>
</template>
<script>
import Input from "@/components/FormFields/Input/Input.vue";
import CheckBox from "@/components/FormFields/CheckBox/CheckBox.vue";
import { formValidation } from "@/mixins/formValidation";

export default {
  name: "FormCfgEmail",
  components: { Input, CheckBox },
  mixins: [formValidation],
  props: {},
  data() {
    return {
      formFieldsState: {
        name: true,
        email: true,
        accept: true,
      },
    };
  },
  computed: {
    setDealerContent() {
      return this.id_distrito != ""
        ? this.distritos
        : [{ option: "Selecione primeiro um distrito" }];
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "./FormStyle.scss";
</style>
